import { config } from "@/config";
import { usePanelProps } from "@/context/panel-props-context";
import { AGENTS } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { memo, useState } from "react";
import { useParams } from "react-router-dom";
import SplashScreen from "../layout/splash-screen";

export default memo(function IsometricFrame() {
  const { id = "", agent } = useParams();
  const { panelProps } = usePanelProps();

  const [isLoading, setIsLoading] = useState(true);
  const isArchitectureAgent = agent === AGENTS.ARCHITECTURE_AGENT;
  let url = config.isometricUrl;
  if (isArchitectureAgent) {
    url = `${url}?uuid=${id}`;
  } else if (panelProps?.mode === "unified_model" && panelProps?.uuid) {
    url = url + `?mode=unified_model&uuid=${panelProps.uuid}`;
  } else if (
    panelProps?.mode === "diagram" &&
    panelProps?.messageId &&
    panelProps?.uuid
  ) {
    url =
      url +
      `?mode=diagram&message=${panelProps.messageId}&uuid=${panelProps.uuid}`;
  }
  if (url === config.isometricUrl) return null;
  return (
    <div
      className={cn(
        `relative h-full w-full `,
        !isArchitectureAgent && "px-4 pb-4"
      )}
    >
      {isLoading && (
        <div className="mt-2">
          <SplashScreen />
        </div>
      )}

      <iframe
        loading="lazy"
        className={cn("h-full w-full ", !isArchitectureAgent && "px-4 pb-4")}
        src={url}
        onLoad={() => setIsLoading(false)}
      />
    </div>
  );
});
